// import Vue from "vue";
// import VueRouter from "vue-router";

import { createWebHistory, createRouter } from 'vue-router'

import routes from './routes'
// import VueMeta from "vue-meta";
import store from '@/state/store'
import { abortPendingRequests } from '@/api'

// Vue.use(VueRouter);

// Vue.use(VueMeta, {
//   // The component option name that vue-meta looks for meta info on.
//   keyName: "page",
// });
const router = createRouter({
  history: createWebHistory(),
  routes,
  // mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  abortPendingRequests()

  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.requiresAuth)
  const permissionRequired = routeTo.meta.requiredPermission

  // If auth isn't required for the route, just continue.
  if (!authRequired) return next()

  const user = store.state.auth.user
  // If auth is required and the user is logged in...
  if (user && Date.now() < user.tokenExpiry) {
    // Check if user has the required permission.
    if (
      permissionRequired &&
      !store.getters['auth/authUserHasPermission'](permissionRequired)
    ) {
      // If the user doesn't have permission, redirect to 403 page.
      return next({ name: '403' })
    }
    return next()
  }

  // If auth is required and the user is NOT currently logged in, redirect to login.
  // window.location.href = "/auth/login";
  next({
    name: 'login',
    query: { redirectFrom: routeTo.fullPath },
  })
})

let lastPath = ''

router.afterEach((to) => {
  if (to.fullPath !== lastPath) {
    const el = document.getElementById('elePageTitle')
    if (el) {
      el.innerHTML = ''
    }
    lastPath = to.fullPath
  }
})

// router.beforeResolve(async (routeTo, routeFrom, next) => {
// Create a `beforeResolve` hook, which fires whenever
// `beforeRouteEnter` and `beforeRouteUpdate` would. This
// allows us to ensure data is fetched even when params change,
// but the resolved route does not. We put it in `meta` to
// indicate that it's a hook we created, rather than part of
// Vue Router (yet?).
// try {
//   // For each matched route...
//   for (const route of routeTo.matched) {
//     await new Promise((resolve, reject) => {
//       // If a `beforeResolve` hook is defined, call it with
//       // the same arguments as the `beforeEnter` hook.
//       if (route.meta && route.meta.beforeResolve) {
//         route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
//           // If the user chose to redirect...
//           if (args.length) {
//             // If redirecting to the same route we're coming from...
//             // Complete the redirect.
//             next(...args);
//             reject(new Error("Redirected"));
//           } else {
//             resolve();
//           }
//         });
//       } else {
//         // Otherwise, continue resolving the route.
//         resolve();
//       }
//     });
//   }
//   // If a `beforeResolve` hook chose to redirect, just return.
// } catch (error) {
//   return;
// }

// // If we reach this point, continue resolving the route.
// next();
// });

export default router
